'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _CarbonFootprint = require('./CarbonFootprint.css');

var _CarbonFootprint2 = _interopRequireDefault(_CarbonFootprint);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CarbonFootprint = (_dec = (0, _reactCssModules2.default)(_CarbonFootprint2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(CarbonFootprint, _Component);

  function CarbonFootprint(props) {
    (0, _classCallCheck3.default)(this, CarbonFootprint);
    return (0, _possibleConstructorReturn3.default)(this, (CarbonFootprint.__proto__ || (0, _getPrototypeOf2.default)(CarbonFootprint)).call(this, props));
  }

  (0, _createClass3.default)(CarbonFootprint, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var title = 'Carbon footprint';
      var description = 'Get your money out of fossil fuels. Use Fossil Free Funds to see the carbon footprint of your investments.';
      var url = _config2.default.domain + _config2.default.routes.carbonfootprint;

      var bannerImage = 'footprint';
      var bannerHeadline = 'Carbon footprint';
      var bannerSubtitle = 'Measuring financed emissions';

      //
      return _react2.default.createElement(
        'div',
        null,
        _container2.default.helmet(title, description, url),
        _react2.default.createElement(
          'div',
          { styleName: 'image-banner-container' },
          _react2.default.createElement(
            'div',
            { styleName: 'image-banner-container-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'image-banner-' + bannerImage },
              _react2.default.createElement(
                'div',
                { styleName: 'image-banner-headline' },
                bannerHeadline
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'image-banner-subtitle' },
                bannerSubtitle
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'page' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(_components.FootprintDeprecated, null),
            _react2.default.createElement(
              'div',
              { styleName: 'title' },
              'Measure the carbon emissions financed by your mutual fund investments'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'x-carbon-footprint-info-photo' },
              _react2.default.createElement(
                'div',
                { styleName: 'x-carbon-footprint-info' },
                _react2.default.createElement(
                  'p',
                  null,
                  'Fossil fuel companies and those emitting large quantities of CO2 have come under increasing levels of scrutiny for their large and direct responsibility for climate change. For investors, such companies are increasingly seen as potentially risky investments, as they are likely to face increasing costs, shrinking profits, and a need to fundamentally redesign their business models.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  '"Carbon footprinting" a mutual fund means accounting for the quantification and management of GHGs. It is the first step towards understanding an investor\u2019s impact on climate change. A carbon footprint is calculated by measuring and/or estimating the quantities and assessing the sources of various GHG emissions that can be directly or indirectly attributed to the activities of the underlying holdings.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'To independently analyze and calculate carbon footprints for the mutual funds, we used the ',
                  _react2.default.createElement(
                    'strong',
                    null,
                    'Carbon Footprint Analysis Tool'
                  ),
                  ' of yourSRI.com.'
                )
              ),
              _react2.default.createElement('div', {
                styleName: 'x-carbon-footprint-photo',
                title: 'Carbon footprinting'
              })
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'image-banner-subtitle' },
              _react2.default.createElement(
                'em',
                null,
                'Brought to you by As You Sow - Carbon footprint profile delivered by yourSRI.com'
              )
            )
          ),
          _react2.default.createElement(_components.GetStartedInput, null),
          _react2.default.createElement(
            'div',
            { styleName: 'content-container' },
            _react2.default.createElement(
              'div',
              { styleName: 'content-container-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'section-title' },
                'The concept of financed emissions'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The basis for a carbon footprint is the annual GHG emissions of each company within the respective fund. All direct operations, as well as energy and heat consumption, are measured in metric tonnes of carbon dioxide equivalent (tCO2e). The footprint is based on the full holdings of each fund per the most recently available Morningstar data, and the corresponding greenhouse gas emission data.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'To allocate company GHG emissions to a fund, the value of shares held by the fund is set in relation to the company\u2019s market capitalization. This ratio is multiplied with the emissions of the company, resulting in the emissions "owned" by the investor. By aggregating the information on a fund level, an investment carbon footprint for the fund is established and expressed in absolute and relative terms.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The described approach allows for the direct association and quantification of the emissions per investment and per fund. It also enables investors to compare the climate-intensity of one fund with another. For the ranking of the assessed funds, a relative metric has been applied to avoid any bias resulting from the size of the funds.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'yourSRI.com\u2019s company GHG data covers the entire investable universe. This is achieved through collecting data from different data sources, data validation and estimation of missing data points with 800 proprietary models. Thorough stress tests of the data are conducted to ensure accuracy.'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.links.yoursrimethodology,
                    xstrong: true,
                    title: 'yourSRI.com Methodology' },
                  'Read the yourSRI.com Carbon Footprint Analysis Tool methodology document',
                  _react2.default.createElement(_components.LinkIcon, null)
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'section-title' },
                'Relative carbon footprint'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The relative carbon footprint expresses the greenhouse gas footprint of an investment sum. It is a normalized measure of a portfolio\u2019s contribution to climate change that enables comparison with a benchmark, between portfolios, and between individual investments. The relative carbon footprint is measured in Total Carbon Emissions expressed as per currency invested.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'section-title' },
                'Scope 1, 2, and 3 emissions'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Greenhouse gas (GHG) emissions are classified as per the Greenhouse Gas Protocol and are grouped in categories called Scope 1, Scope 2 and Scope 3.'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'Scope 1 GHG emissions'
                ),
                ' are those directly occurring \u201Cfrom sources that are owned or controlled by the institution, including: on\u2010campus stationary combustion of fossil fuels; mobile combustion of fossil fuels by institution owned/controlled vehicles; and &slquo;fugitive emissions\u2019. \u201D'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'Scope 2 emissions'
                ),
                ' are \u201Cindirect emissions generated in the production of electricity consumed by the institution.\u201D'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'Scope 3 emissions'
                ),
                ' are all the other indirect emissions that are \u201Ca consequence of the activities of the institution, but occur from sources not owned or controlled by the institution such as commuting; embodied emissions from extraction, production, and transportation of purchased goods; outsourced activities; contractor\u2010owned vehicles; and line loss from electricity transmission and distribution\u201D. In the data, Scope 3 emissions are conceptually divided into (a) upstream emissions, i.e. emissions stemming from a company\u2019s supply chain and (b) downstream emissions, i.e. emissions from product \u201Cuse phases\u201D during their life cycle.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'section-title' },
                'yourSRI.com'
              ),
              _react2.default.createElement(
                'p',
                null,
                'With its online platform yourSRI.com, CSSP helps asset managers and asset owners worldwide to adequately manage risks related to ESG and Carbon issues. Investors can use the online tool to score mainstream mutual funds, portfolios, and mandates to efficiently benchmark and to compare investments with peers.'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.links.yoursri,
                    xstrong: true,
                    title: 'yourSRI.com' },
                  'Visit yourSRI.com online to learn more',
                  _react2.default.createElement(_components.LinkIcon, null)
                )
              ),
              _react2.default.createElement(_components.AboutBanner, null)
            )
          )
        )
      );
    }
  }]);
  return CarbonFootprint;
}(_react.Component)) || _class);
exports.default = CarbonFootprint;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/CarbonFootprint/CarbonFootprint.js
// module id = 1395
// module chunks = 0